var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-layout flex"},[_c('div',{staticClass:"filter-layout-left flex-space flex-center"},[_vm._t("filter-left")],2),_c('div',{staticClass:"fr-links"},[_vm._t("filter-right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }